/* eslint-disable import/prefer-default-export */
export function formatUSPhone(value?: string | number | null): string {
  if (value == null || value === '') return '';

  const raw = String(value).replace(/\D/g, '');

  if (!raw) return '';

  if (raw.length > 11) return `+${raw}`;

  const digits = raw.length === 11 && raw[0] === '1' ? raw.slice(1) : raw;

  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  if (digits.length <= 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  }

  return `+${raw}`;
}
